import angular from 'angular';
import { paymentTabsComponents } from './tabs';
import { paymentCommonComponents } from './common';
export const paymentComponents = angular
    .module('paymentComponents', [paymentTabsComponents, paymentCommonComponents])
    .name;
